import { ChampionGameStyle, ChampionIcon, GetScalingColorsForTeams } from "@procomps/shared";

import { usePatchStore } from "src/services/patch-ecosystem-store";
import { ALL_LANES } from "src/types/global";
function DefaultCompList() {
  const { defaultComps, championDB } = usePatchStore();
  const getCompMembers = (comp: any) => {
    return [
      comp.Top_Special,
      comp.Jungle_Special,
      comp.Mid_Special,
      comp.Bottom_Special,
      comp.Support_Special,
    ];
  };
  return (
    <div className="flex w-full flex-col items-center justify-start gap-10 ">
      <div className="flex w-full items-center justify-between">
        <div className="font-unbounded text-[20px] font-extrabold uppercase leading-6 text-neutral-0 ">
          Best Team Compositions
        </div>
        <div className="max-w-[572px] font-poppins text-[#8E8E8E] ">
          Explore the strongest team comps of the patch, crafted from synergy and performance data.
          Ideal for team strategies, Clash prep, and finding comps that win together.
        </div>
      </div>
      <div className="flex w-full flex-col items-center justify-start gap-10">
        {defaultComps.map((comp, idx) => (
          <div
            className="flex h-[200px] w-full items-center justify-between gap-6 rounded-full border border-[#393939] p-10 pr-[200px] "
            key={comp.id}
          >
            <div className="flex w-max items-center justify-start gap-6  ">
              <span className="w-12 font-unbounded text-[20px] font-extrabold uppercase leading-6 text-neutral-0 ">
                {idx + 1}
              </span>
              <div className="flex items-center justify-start">
                {ALL_LANES.map((lane, idx) => (
                  <ChampionIcon
                    key={idx}
                    champion={comp[`${lane}_Special`]}
                    className="-ml-4 h-[120px] w-[120px] border-8 border-[#000605]  "
                  />
                ))}
              </div>
            </div>
            <div className="flex min-w-[191.11px] items-center justify-start gap-[12.8px] ">
              <ChampionGameStyle gameStyle={comp.Game_Style} color="neutral" size="3xlarge" />
              <div className="font-unbounded text-[25.6px] font-medium uppercase text-neutral-500  ">
                {comp.Game_Style}
              </div>
            </div>
            <div className="flex  items-center justify-start gap-2">
              <GetScalingColorsForTeams
                teamMembers={getCompMembers(comp)}
                ChampionDB={championDB}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DefaultCompList;
